import Grid from "@mui/material/Grid2";
import { FC } from "react";
import { wrapperCard } from "./card.style";

interface IProps {
  children: React.ReactNode;
}

const CustomCard: FC<IProps> = ({ children }) => {
  return (
    <Grid
      sx={{
        ...wrapperCard,
        background: (theme) => theme?.palette?.secondary?.main,
      }}
    >
      {children}
    </Grid>
  );
};

export default CustomCard;
